module.exports = __webpack_public_path__ + "media/images/main-bg-320-758ca0073c7991ebdb81490bf8d2e803.png";